import React, { Dispatch, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchChatsData } from "@sms/shared/chat/search/search.interface";

import SearchItem from "./search-item/search-item.component";
import styles from "./search.module.scss";

import { ApplicationStore } from "~/app/application.store";
import chatActions from "~/app/chat/chat.actions";

const SearchWrapperComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();

  const searchResults: SearchChatsData = useSelector((state: ApplicationStore) => state.search.searchResults);
  const isLoading: boolean | null = useSelector((state: ApplicationStore) => state.search.isLoading);
  const selectChatId: string | null = useSelector((state: ApplicationStore) => state.chats.selectChatId);

  const handleChangeChat: (data: string | null) => void = useCallback(
    (data: string | null) => {
      dispatch(chatActions.switchSelectChat(data));
    },
    [dispatch]
  );

  return (
    <div className={styles.searchWrapper}>
      {searchResults.chatsByName.length > 0 && (
        <div className={styles.container}>
          <div className={styles.name}>Chats and Contacts</div>
          {searchResults.chatsByName.map((chat, index) => (
            <SearchItem key={index} chatData={chat} handleChangeChat={handleChangeChat} selectChatId={selectChatId} />
          ))}
        </div>
      )}
      {searchResults.chatsByMessage.length > 0 && (
        <div className={styles.container}>
          <div className={styles.name}>Messages</div>
          {searchResults.chatsByMessage.map((chat, index) => (
            <SearchItem key={index} chatData={chat} handleChangeChat={handleChangeChat} selectChatId={selectChatId} />
          ))}
        </div>
      )}
      <div className={styles.container}>
        {isLoading && <div>Loading...</div>}

        {isLoading == false && searchResults.chatsByName.length == 0 && searchResults.chatsByMessage.length == 0 && (
          <div>No Results</div>
        )}
      </div>
    </div>
  );
};

export default SearchWrapperComponent;
